import SyllabusPage from "../components/pages/Syllabus";

export default SyllabusPage;
